export default __webpack_public_path__ + "static/kofi-96681ac593be3c45a8212a2a5603ed42.png";